export default __webpack_public_path__ + "static/media/service_now.1e2915b7.svg";